// components
import { Box } from "../common/box";
import { ItemFigure } from "../common/item-figure";

const ViewBox = ({ customer, box, number, withStatus }) => {
    const ItemFigureWrapper = (props) => (
        <ItemFigure withStatus={withStatus} {...props} />
    );

    return (
        <Box box={box} number={number} customer={customer}
            withStatus={withStatus} ContentComponent={ItemFigureWrapper} />

    )
};

export { ViewBox };
